import styled from "styled-components";
import { Accordion } from "@vds/accordions";

export const StyledAccordion = styled(Accordion)`
`;
